<div style="min-height: 260px; height: 600px !important; overflow-y:auto;">
  <nz-space-item style="min-height: 260px; width: 100% !important">
    <nz-space
      style="
        width: 100% !important;
        padding: 0px;
        margin-left: 0px;
        margin-left: auto;
        font-size: large;
      "
    >
      <nz-space-item
        style="width: 100% !important; padding: 0px; margin-left: 0px"
      >
        <!-- <nz-timeline >
         <nz-timeline-item nzColor="red" *ngFor="let item of activitiesData" [nzDot]="dotTemplate">
           <p>Technical testing 2015-09-01</p>
             <p class="short-name-continer" style=" float: left; margin: 2px; margin: -11px; text-align: center;">
               </p>
               <p [innerHTML]="item.AttendEmpl | shortName"></p>
               <p [innerHTML]="item.AttendUser | shortName"></p>

             <nz-button-group class="activity-list-edit-btn">
               <a nz-button nzType="link" (click)="navigateTo(25, recordId)"><i nz-icon nzType="edit" nzTheme="outline"></i></a>
             </nz-button-group>


         </nz-timeline-item>
       </nz-timeline>
       <ng-template #dotTemplate>
         <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
       </ng-template> -->
        <div style="min-height: 260px;  min-width: 400px;">
          <nz-list
            style="min-height: 600px; width: 100% !important"
            [nzDataSource]="activitiesData"
            [nzRenderItem]="item"
            [nzItemLayout]="'horizontal'"
            class="records-list-comm"
          >
            <nz-list-item>
              <nz-skeleton
                *ngIf="!activitiesData.entries"
                [nzAvatar]="true"
                [nzParagraph]="{ rows: 1 }"
              ></nz-skeleton>
              <ng-template #item let-item>
                <nz-comment
                  [nzAuthor]="item.AttendUser"
                  [nzDatetime]="item.Recontact"
                >
                  <nz-avatar
                    nz-comment-avatar
                    *ngIf="item.Action == 'C'"
                    nzIcon="phone"
                    style="margin: auto"
                  ></nz-avatar>
                  <nz-avatar
                    nz-comment-avatar
                    *ngIf="item.Action == 'M'"
                    nzIcon="deployment-unit"
                    style="margin: auto"
                  ></nz-avatar>
                  <nz-avatar
                    nz-comment-avatar
                    *ngIf="item.Action == 'T'"
                    nzIcon="unordered-list"
                    style="margin: auto"
                  ></nz-avatar>
                  <nz-avatar
                    nz-comment-avatar
                    *ngIf="item.Action == 'N'"
                    nzIcon="mail"
                    style="margin: auto"
                  ></nz-avatar>
                  <nz-avatar
                    nz-comment-avatar
                    *ngIf="item.Action == 'E'"
                    nzIcon="book"
                    style="margin: auto"
                  ></nz-avatar>
                  <div
                    nzIcon="fund-view"
                    style="margin-left: -15px"
                    *ngIf="item.Action == 'N' && item.U_ITM_BWEB_READ === 'Y'"
                  >
                    <nz-badge
                      style="margin-right: auto"
                      [nzCount]="item.U_ITM_BWEB_CREAD"
                    >
                      <button
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        class="email-not-badge"
                        nzClickHide="false"
                        nzTrigger="hover"
                        nzPlacement="bottomRight"
                      >
                        <i nz-icon nzType="eye" nzTheme="outline"></i>
                      </button>
                    </nz-badge>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>
                        <li nz-menu-item>
                          <h2>{{ "Viewed At" | locale }}</h2>
                        </li>
                        <li
                          nz-menu-item
                          *ngFor="let item of item.U_ITM_BWEB_DREAD.split(';')"
                        >
                          <nz-tag [nzColor]="'green'" *ngIf="item !== ''">{{
                            item
                          }}</nz-tag>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>

                  <nz-comment-content>
                    <ng-container>
                      <div style="margin: 2px">
                        <div style="float: left; margin: 2px">
                          <p style="margin: 2px">
                            {{ item.BeginTime | minuteSeconds }}
                            {{ item.BeginTime !== item.ENDTime ? " - " : "" }}
                            {{
                              item.BeginTime === item.ENDTime
                                ? ""
                                : (item.ENDTime | minuteSeconds)
                            }}
                          </p>
                          <p style="margin: 2px" [innerHTML]="item.Notes"></p>
                        </div>
                        <div style="display: inline-block">
                          <!-- class="short-name-continer" style=" float: left; margin: 2px; margin: -11px; text-align: center;"> -->
                          <!-- <div [innerHTML]="item.AttendEmpl | shortName"></div>
                 <div [innerHTML]="item.AttendUser | shortName"></div> -->
                          <nz-tag
                            style="margin: 5px"
                            *ngIf="item.AttendEmpl !== ' '"
                            >{{ item.AttendEmpl }}</nz-tag
                          >

                          <!-- <nz-tag style="margin: 5px;" *ngIf="item.AttendUser !== ' '" >{{item.AttendUser}}</nz-tag> -->
                        </div>
                      </div>
                    </ng-container>
                    <!-- <nz-button-group class="activity-list-edit-btn">
                      <a
                        nz-button
                        nzType="link"
                        (click)="navigateTo(25, recordId)"
                        ><i nz-icon nzType="edit" nzTheme="outline"></i
                      ></a>
                    </nz-button-group> -->
                    <!-- <p>{{ item.ClgCode}}</p>
               <p>{{ item.OprLine}}</p>
               <p>{{ item.Recontact}}</p>
               <p>{{ item.endDate}}</p>
               <p>{{ item.U_ITM_ACT_GUID}}</p>
               <p>{{ item.U_ITM_BWEB_CREAD}}</p>
               <p>{{ item.U_ITM_BWEB_DREAD}}</p>
               <p>{{ item.U_ITM_BWEB_EML_BCC}}</p>
               <p>{{ item.U_ITM_BWEB_EML_CC}}</p>
               <p>{{ item.U_ITM_BWEB_EML_TO}}</p>
               <p>{{ item.U_ITM_BWEB_READ}}</p>

               <p>{{ item.U_ITM_BWEB_EML_TO}}</p> -->
                  </nz-comment-content>
                  <!--<nz-comment-action style="display: inline-block; margin: 5px;">Reply to</nz-comment-action> -->
                </nz-comment>
                <nz-divider></nz-divider>
              </ng-template>
            </nz-list-item>
          </nz-list>
        </div>
      </nz-space-item>
    </nz-space>
  </nz-space-item>
</div>
